/** IPON — Intellectual Property Ontario. */
export const IPON_TASKS = [
  {
    id: 1,
    name: "IP strategy intake",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Confirm Ontario SME eligibility", completed: false },
      { id: "1-2", name: "Assess IP assets (patents, trademarks, trade secrets)", completed: false },
      { id: "1-3", name: "Select IPON service (strategy, patent, TM support)", completed: false },
    ],
  },
  {
    id: 2,
    name: "Application & advisor match",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Submit IPON application with business overview", completed: false },
      { id: "2-2", name: "Work with assigned IP advisor on action plan", completed: false },
    ],
  },
  {
    id: 3,
    name: "Execute IP plan",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Complete filings or FTO analysis per plan", completed: false },
      { id: "3-2", name: "Submit reimbursement claims for eligible costs", completed: false },
    ],
  },
];

/** AccelerateIP — British Columbia IP funding. */
export const ACCELERATE_IP_TASKS = [
  {
    id: 1,
    name: "BC IP eligibility",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Confirm BC incorporation or operations", completed: false },
      { id: "1-2", name: "Define IP development or protection scope", completed: false },
    ],
  },
  {
    id: 2,
    name: "Funding application",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Prepare IP project budget and timeline", completed: false },
      { id: "2-2", name: "Submit via Innovate BC / AccelerateIP", completed: false },
    ],
  },
  {
    id: 3,
    name: "Delivery & claim",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Complete IP work with approved vendors", completed: false },
      { id: "3-2", name: "File final report and reimbursement", completed: false },
    ],
  },
];
